import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  // State for Mobile Menu Toggle
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  // State for Mobile Dropdowns (Track which one is open)
  const [activeMobileDropdown, setActiveMobileDropdown] = useState<string | null>(null);

  const toggleMobileDropdown = (menuName: string) => {
    setActiveMobileDropdown(activeMobileDropdown === menuName ? null : menuName);
  };

  return (
    <div className="absolute top-0 left-0 w-full z-50 font-sans">
      
      {/* --- HEADER CONTENT --- */}
      <header className="bg-transparent relative"> {/* Added relative for positioning mobile menu */}
        <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
          <div className="flex justify-between items-center py-4">

            {/* Logo */}
            <Link to="/" className="flex-shrink-0 cursor-pointer">
              <img src="/logo.png" alt="DreamLadder" className="h-10 sm:h-14 w-auto" /> {/* Slightly smaller on mobile */}
            </Link>

            {/* Right Side Container */}
            <div className="flex items-center">

              {/* ----------------------- */}
              {/* DESKTOP NAVIGATION (Unchanged) */}
              {/* ----------------------- */}
              <nav className="hidden md:flex items-center space-x-6 mr-8">

                {/* We Dropdown */}
                <div className="relative group">
                  <button className="flex items-center text-[17px] font-medium text-gray-800 hover:text-[#e31e24] transition-colors">
                    We
                    <svg className="ml-1 h-4 w-4 transition-transform duration-200 group-hover:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className="absolute top-full left-0 mt-2 w-48 bg-white border border-gray-100 rounded-xl shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                    <div className="py-1">
                      <Link to="/about" className="block px-4 py-2 text-[16px] text-gray-600 hover:bg-gray-50 hover:text-[#e31e24]">About Us</Link>
                      <Link
        to="/who-we-serve"
        className="block px-4 py-2 text-[16px] text-gray-600 hover:bg-gray-50 hover:text-[#e31e24]"
      >
        Who We Serve
      </Link>
                     {/*  <a href="#connect" className="block px-4 py-2 text-[16px] text-gray-600 hover:bg-gray-50 hover:text-[#e31e24]">Connect</a> */}
                    </div>
                  </div>
                </div>

                {/* Services Dropdown 
                <div className="relative group">
                  <button className="flex items-center text-[17px] font-medium text-gray-800 hover:text-[#e31e24] transition-colors">
                    Services
                    <svg className="ml-1 h-4 w-4 transition-transform duration-200 group-hover:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className="absolute top-full left-0 mt-2 w-56 bg-white border border-gray-100 rounded-xl shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                    <div className="py-1">
                      <a href="#what-we-offer" className="block px-4 py-2 text-[16px] text-gray-600 hover:bg-gray-50 hover:text-[#e31e24]">What we offer</a>
                      <a href="#personalised-portfolio" className="block px-4 py-2 text-[16px] text-gray-600 hover:bg-gray-50 hover:text-[#e31e24]">Personalised Portfolio</a>
                    </div>
                  </div>
                </div>
                */}

                {/* Services Dropdown */}
{/* Services Dropdown */}
{/* Services Dropdown */}
<div className="relative group">
  <button className="flex items-center text-[17px] font-medium text-gray-800 hover:text-[#e31e24] transition-colors py-2">
    Services
    <svg className="ml-1 h-4 w-4 transition-transform duration-200 group-hover:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  {/* Level 1 Container */}
  <div className="absolute top-full left-0 mt-2 w-56 bg-white border border-gray-100 rounded-xl shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 py-1">
    
    {/* Sub-item with Flyout */}
    <div className="relative group/sub">
      <div className="flex items-center justify-between px-4 py-2 text-[16px] text-gray-600 hover:bg-gray-50 hover:text-[#e31e24] cursor-pointer transition-colors">
        What we Offer
        <svg className="h-3.5 w-3.5 opacity-60 group-hover/sub:rotate-180 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      {/* Level 2: Adjusted top to align with the main Level 1 Box border */}
      <div className="absolute top-[-5px] left-full ml-0 w-52 bg-white border border-gray-100 rounded-xl shadow-lg opacity-0 invisible group-hover/sub:opacity-100 group-hover/sub:visible transition-all duration-200 py-1">
        <ul className="py-1">
          {[
            "Mutual Funds",
            "PMS / AIF",
            "Bonds",
            "Structured Products",
            "Legacy / Estate Planning",
            "Insurance",
          ].map((item) => (
            <li key={item}>
              <Link 
                to={`/${item.toLowerCase().replace(/\s+/g, '-').replace('/', '')}`} 
                className="block px-4 py-2 text-[15px] text-gray-600 hover:bg-gray-50 hover:text-[#e31e24] transition-colors"
              >
                {item}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>

    <Link 
      to="/bespoke-portfolios" 
      className="block px-4 py-2 text-[16px] text-gray-600 hover:bg-gray-50 hover:text-[#e31e24] transition-colors"
    >
      Bespoke Portfolios
    </Link>
  </div>
</div>


                {/* Insights Dropdown */}
                <div className="relative group">
                  <button className="flex items-center text-[17px] font-medium text-gray-800 hover:text-[#e31e24] transition-colors">
                    Insights
                    <svg className="ml-1 h-4 w-4 transition-transform duration-200 group-hover:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className="absolute top-full left-0 mt-2 w-48 bg-white border border-gray-100 rounded-xl shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                    <div className="py-1">
                      <Link to="/blogs" className="block px-4 py-2 text-[16px] text-gray-600 hover:bg-gray-50 hover:text-[#e31e24]">Blogs</Link>
                      <Link to="/media" className="block px-4 py-2 text-[16px] text-gray-600 hover:bg-gray-50 hover:text-[#e31e24]">Media</Link>
                      <Link to="/calculator" className="block px-4 py-2 text-[16px] text-gray-600 hover:bg-gray-50 hover:text-[#e31e24]">Calculator</Link>
                    </div>
                  </div>
                </div>

                {/* Connect Link 
                <a href="#connect" className="text-[17px] font-medium text-gray-800 hover:text-[#e31e24] transition-colors">
                  Connect
                </a>
                */}

                <Link to="/connect" className="text-[17px] font-medium text-gray-800 hover:text-[#e31e24] transition-colors">
                  Connect
                </Link>
              </nav>

              {/* Action Buttons Section (Desktop: Visible, Mobile: Hidden) */}
              <div className="hidden md:flex items-center space-x-3"> 
                {/*
                <a href="https://dreamladdercapital.my-portfolio.co.in/app/#/login" className="px-5 py-0.5 text-[17px] font-bold text-white bg-[#e31e24] rounded hover:bg-[#434242] transition-colors duration-300 shadow-sm">
                  Login
                </a>
                <a href="https://dreamladdercapital.my-portfolio.co.in/app/#/kycOnBoarding/mobileSignUp" className="px-5 py-0.5 text-[17px] font-bold text-white bg-[#e31e24] rounded hover:bg-[#434242] transition-colors duration-300 shadow-sm">
                  Sign Up
                </a>
                */}
                 <a href="https://dreamladdercapital.my-portfolio.co.in/app/#/login" target="_blank" rel="noreferrer" className="flex items-center px-3 py-1 md:px-4 bg-red-600 border-2 border-red-600 text-white rounded-full hover:bg-[#434242]  hover:border-[#434242] transition duration-300 font-medium text-[10px] md:text-[16px] shadow-xl shadow-red-900/20">
                           Login
                        </a>
                        <a href="https://dreamladdercapital.my-portfolio.co.in/app/#/kycOnBoarding/mobileSignUp" target="_blank" rel="noreferrer" className="flex items-center px-3 py-1 md:px-4 bg-red-600 border-2 border-red-600 text-white rounded-full hover:bg-[#434242]  hover:border-[#434242] transition duration-300 font-medium text-[10px] md:text-[16px] shadow-xl shadow-red-900/20">
                          Sign Up
                        </a>
                
              </div>

              {/* ----------------------- */}
              {/* MOBILE MENU TOGGLE BUTTON */}
              {/* ----------------------- */}
              <button 
                className="md:hidden p-2 text-gray-800 focus:outline-none"
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              >
                {isMobileMenuOpen ? (
                  /* Close Icon */
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                ) : (
                  /* Hamburger Icon */
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                )}
              </button>

            </div>
          </div>

          {/* ----------------------- */}
          {/* MOBILE MENU DRAWER */}
          {/* ----------------------- */}
          <div className={`${isMobileMenuOpen ? 'block' : 'hidden'} md:hidden absolute top-full left-0 w-full bg-white shadow-xl border-t border-gray-100 transition-all duration-300 ease-in-out`}>
            <div className="flex flex-col px-6 py-4 space-y-4 max-h-[80vh] overflow-y-auto">
              
              {/* Mobile We Dropdown */}
              <div>
                <button 
                  onClick={() => toggleMobileDropdown('we')}
                  className="flex justify-between items-center w-full text-[17px] font-medium text-gray-800"
                >
                  We
                  <svg className={`h-4 w-4 transition-transform duration-200 ${activeMobileDropdown === 'we' ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                <div className={`${activeMobileDropdown === 'we' ? 'block' : 'hidden'} mt-2 pl-4 space-y-2 border-l-2 border-[#e31e24]`}>
                  <Link to="/about" className="block text-[16px] text-gray-600 py-1" onClick={() => setIsMobileMenuOpen(false)}>About Us</Link>
                  <Link to="/connect" className="block text-[16px] text-gray-600 py-1" onClick={() => setIsMobileMenuOpen(false)}>Connect</Link>
                </div>
              </div>

              {/* Mobile Services Dropdown */}
              <div>
                <button 
                  onClick={() => toggleMobileDropdown('services')}
                  className="flex justify-between items-center w-full text-[17px] font-medium text-gray-800"
                >
                  Services
                  <svg className={`h-4 w-4 transition-transform duration-200 ${activeMobileDropdown === 'services' ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                <div className={`${activeMobileDropdown === 'services' ? 'block' : 'hidden'} mt-2 pl-4 space-y-2 border-l-2 border-[#e31e24]`}>
                  <a href="#what-we-offer" className="block text-[16px] text-gray-600 py-1" onClick={() => setIsMobileMenuOpen(false)}>What we offer</a>
                  <a href="#who-we-serve" className="block text-[16px] text-gray-600 py-1" onClick={() => setIsMobileMenuOpen(false)}>Who we serve</a>
                  <a href="#personalised-portfolio" className="block text-[16px] text-gray-600 py-1" onClick={() => setIsMobileMenuOpen(false)}>Personalised Portfolio</a>
                </div>
              </div>

              {/* Mobile Insights Dropdown */}
              <div>
                <button 
                  onClick={() => toggleMobileDropdown('insights')}
                  className="flex justify-between items-center w-full text-[17px] font-medium text-gray-800"
                >
                  Insights
                  <svg className={`h-4 w-4 transition-transform duration-200 ${activeMobileDropdown === 'insights' ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                <div className={`${activeMobileDropdown === 'insights' ? 'block' : 'hidden'} mt-2 pl-4 space-y-2 border-l-2 border-[#e31e24]`}>
                  <a href="#blogs" className="block text-[16px] text-gray-600 py-1" onClick={() => setIsMobileMenuOpen(false)}>Blogs</a>
                  <a href="#media" className="block text-[16px] text-gray-600 py-1" onClick={() => setIsMobileMenuOpen(false)}>Media</a>
                  <Link to="/calculator" className="block text-[16px] text-gray-600 py-1" onClick={() => setIsMobileMenuOpen(false)}>Calculator</Link>
                </div>
              </div>

              {/* Mobile Connect Link */}
              <a href="#connect" className="block text-[17px] font-medium text-gray-800" onClick={() => setIsMobileMenuOpen(false)}>
                Connect
              </a>

              {/* Mobile Buttons */}
              <div className="pt-4 flex flex-col space-y-3">
                <a
                  href="#login"
                  target="_blank" rel="noreferrer"
                  className="text-center px-5 py-2 text-[17px] font-bold text-white bg-[#e31e24] rounded hover:bg-[#434242] transition-colors duration-300"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Login
                </a>
                <a
                  href="#register"
                  target="_blank" rel="noreferrer"
                  className="text-center px-5 py-2 text-[17px] font-bold text-white bg-[#e31e24] rounded hover:bg-[#434242] transition-colors duration-300"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Sign Up
                </a>
              </div>

            </div>
          </div>

        </div>
      </header>
    </div>
  );
};

export default Header;